import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { checkIfMultiplePastRegimenExists } from "../utils/checkIfMultiplePastRegimenExists";

export const useIfMultiplePastRegimenExists = () => {
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const [ifMultiplePastRegimenExists, setIfMultiplePastRegimenExists] =
    useState(false);

  useEffect(() => {
    if (singleMedicalPaOrder) {
      setIfMultiplePastRegimenExists(
        checkIfMultiplePastRegimenExists(singleMedicalPaOrder),
      );
    }
  }, [singleMedicalPaOrder]);

  return ifMultiplePastRegimenExists;
};
